class CarouselShorts {
  constructor(element) {
    this.carousel = element.querySelector('.sc-carousel-wrap')
    this.slides = this.carousel.querySelectorAll('.sc-carousel-slide')
    this.prevButton = element.querySelector('.sc-carousel-controll-button_prev')
    this.nextButton = element.querySelector('.sc-carousel-controll-button_next')
    this.menuItems = element.querySelectorAll('.carousel-menu li')
    this.currentIndex = 0
    this.currentPosition = 0
    this.element = element
    this.isHovered = false

    this.init()
    this.accesbility();
  }

  init() {
    this.showSlide(this.currentIndex);
    this.prevButton?.addEventListener('click', () => this.prev())
    this.nextButton?.addEventListener('click', () => this.next())
    this.menuItems.forEach((item, index) => {
      item.addEventListener('click', () => this.goTo(index))
    });
    this.carousel.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true })
    this.carousel.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true })
    this.carousel.addEventListener('touchend', () => this.handleTouchEnd(), { passive: true })

    this.carousel.addEventListener('mousedown', (e) => this.handleMouseDown(e))
    this.carousel.addEventListener('mousemove', (e) => this.handleMouseMove(e))
    this.carousel.addEventListener('mouseup', () => this.handleMouseUp())
    this.carousel.addEventListener('mouseleave', () => this.handleMouseUp())
  }

  showSlide(index) {
    if (index >= 0 && index < this.slides.length) {
      let slideWidth = this.slides[index].offsetWidth
      let newLeft = -index * slideWidth
      
      if(index > 0) {
        newLeft = -this.slides[index].offsetLeft
      }

      this.currentPosition = newLeft
      
      this.carousel.style.position = 'relative'
      this.carousel.style.transform = `translate(${newLeft}px, 0)` 
      this.currentIndex = index
    }
  }

  goTo(index) {
    this.showSlide(index)
  }

  prev() {
    this.goTo(this.currentIndex - 1 < 0 ? this.slides.length - 1 : this.currentIndex - 1)
  }

  next() {
    this.goTo(this.currentIndex + 1 >= this.slides.length ? 0 : this.currentIndex + 1)
  }


  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX
  }

  handleTouchMove(e) {
    if(this.touchStartX === null) return;
    const touchCurrentX = e.touches[0].clientX
    const diffX = this.touchStartX - touchCurrentX
    if(diffX > 50) { 
      this.next()
      this.touchStartX = null
    } else if (diffX < -50) { 
      this.prev();
      this.touchStartX = null
    }
  }

  handleTouchEnd() {
    this.touchStartX = null
  }

  handleMouseDown(e) {
    this.touchStartX = e.clientX
    this.isDragging = true
    e.preventDefault()
  }

  handleMouseMove(e) {
    if(!this.isDragging || this.touchStartX === null) return false;
    const touchCurrentX = e.clientX
    const diffX = this.touchStartX - touchCurrentX
    this.carousel.style.transform = `translate(${this.currentPosition - diffX}px, 0)` 
    if(diffX > 200) { 
      this.next()
      this.isDragging = false
      this.touchStartX = null
    } else if (diffX < -200) { 
      this.prev()
      this.isDragging = false
      this.touchStartX = null
    }

    this.diffX = diffX
  }

  handleMouseUp() {
    if(this.diffX > 20) {
      this.next()
      this.diffX = 0
    }
    else if(this.diffX < -20) {
      this.prev()
      this.diffX = 0
    }

    this.isDragging = false
    this.touchStartX = null
  }
  accesbility() {
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)

    this.element.addEventListener('mouseenter', this.handleMouseEnter)
    this.element.addEventListener('mouseleave', this.handleMouseLeave)
    window.addEventListener('keydown', this.handleKeyDown);
  }

  handleMouseEnter() {
    this.isHovered = true
  }

  handleMouseLeave() {
    this.isHovered = false
  }
  handleKeyDown(event) {
    if(this.isHovered == false) return;
    switch(event.key) {
      case 'ArrowLeft':
        this.prev()
        break;
      case 'ArrowRight':
        this.next()
        break;
    }
  }
}


const API_BASE_URL = 'https://www.googleapis.com/youtube/v3'
const THUMBNAIL_BASE_URL = 'https://i.ytimg.com/vi'
const CACHE_DURATION = 5 * 24 * 60 * 60 * 1000
const TOTAL_SEARCH_RESULTS = 500
const CACHE_KEYS_KEY = 'ytshorts_keys'

async function parseChannelId(input, apiKey) {
  if (!input) return ''
  const value = input.trim().replace(/(\?.*)|(\/(videos|about|featured|shorts).*)$/i, '')
  if (/^UC[a-zA-Z0-9_-]{22}$/.test(value)) return value
  const channelMatch = value.match(/youtube\.com\/channel\/(UC[a-zA-Z0-9_-]{22})/i)
  if (channelMatch?.[1]) return channelMatch[1]
  const handleMatch = value.match(/@([a-zA-Z0-9_-]+)/)
  if (handleMatch?.[1]) {
    const handle = '@' + handleMatch[1]
    const url = `${API_BASE_URL}/channels?part=id&forHandle=${handle}&key=${apiKey}`
    try {
      const res = await fetch(url)
      const data = await res.json()
      return data.items?.[0]?.id || ''
    } catch (e) {
      console.error('Failed to resolve handle:', e)
      return ''
    }
  }
  if (/^[a-zA-Z0-9_-]+$/.test(value)) {
    const url = `${API_BASE_URL}/channels?part=id&forUsername=${value}&key=${apiKey}`
    try {
      const res = await fetch(url)
      const data = await res.json()
      return data.items?.[0]?.id || ''
    } catch (e) {
      console.error('Failed to resolve username:', e)
      return ''
    }
  }
  return ''
}

async function isShortViaThumbnail(videoId) {
  const url = `${THUMBNAIL_BASE_URL}/${videoId}/oar1.jpg`
  try {
    const res = await fetch(url, { method: 'HEAD' })
    return res.status === 200
  } catch {
    return false
  }
}

function manageCache(cacheKey, cacheEnabled, data = null) {
  if (data) {
    const cacheData = { data, timestamp: Date.now() }
    localStorage.setItem(cacheKey, JSON.stringify(cacheData))
    const keys = JSON.parse(localStorage.getItem(CACHE_KEYS_KEY) || '[]')
    if (!keys.includes(cacheKey)) {
      keys.push(cacheKey)
      localStorage.setItem(CACHE_KEYS_KEY, JSON.stringify(keys))
    }
    return data
  }
  if (cacheEnabled !== 'on') return null
  const cached = localStorage.getItem(cacheKey)
  if (!cached) return null
  const { data: cachedData, timestamp } = JSON.parse(cached)
  return Date.now() - timestamp < CACHE_DURATION ? cachedData : null
}

async function fetchShortsData(config) {
  const { apiKey, ytUrl, maxCount, cache, titleViews, sort } = config
  const channelId = await parseChannelId(ytUrl, apiKey)
  if (!channelId) throw new Error('Invalid channel ID')
  const cacheKey = `youtubeShortsCache_${channelId}`
  const cachedData = manageCache(cacheKey, cache)
  if (cachedData) {
    document.querySelector('.sc-loader-flat')?.remove()
    return cachedData
  }
  const searchPageSize = maxCount
  let videoIds = []
  let nextPageToken = ''
  for (let fetched = 0; fetched < TOTAL_SEARCH_RESULTS;) {
    const url = new URL(`${API_BASE_URL}/search`)
    url.searchParams.set('part', 'snippet')
    url.searchParams.set('channelId', channelId)
    url.searchParams.set('maxResults', searchPageSize)
    url.searchParams.set('order', sort)
    url.searchParams.set('type', 'video')
    url.searchParams.set('videoDuration', 'short')
    url.searchParams.set('videoSyndicated', 'true')
    url.searchParams.set('videoEmbeddable', 'true')
    url.searchParams.set('key', apiKey)
    if (nextPageToken) {
      url.searchParams.set('pageToken', nextPageToken)
    }
    const response = await fetch(url)
    if (!response.ok) throw new Error(`Search error: ${response.status}`)
    const data = await response.json()
    const ids = (data.items || []).map(item => item.id.videoId).filter(Boolean)
    videoIds.push(...ids)
    fetched += ids.length
    if (!data.nextPageToken) break
    nextPageToken = data.nextPageToken
  }
  const chunks = []
  for (let i = 0; i < videoIds.length; i += 50) {
    const chunk = videoIds.slice(i, i + 50)
    const videoUrl = `${API_BASE_URL}/videos?part=snippet,contentDetails,statistics&id=${chunk.join(',')}&key=${apiKey}`
    const res = await fetch(videoUrl)
    if (!res.ok) throw new Error(`Videos error: ${res.status}`)
    const videoData = await res.json()
    chunks.push(...videoData.items)
  }
  const filtered = await Promise.all(
    chunks.map(async video => (await isShortViaThumbnail(video.id)) ? video : null)
  )
  const shorts = filtered.filter(Boolean).map(video => ({
    settings: {
      id: video.id || 0,
      url: `https://www.youtube.com/shorts/${video.id}`,
      image: `${THUMBNAIL_BASE_URL}/${video.id}/oar1.jpg`,
      title: video.snippet?.title || '',
      views: video.statistics?.viewCount || 0,
      title_views: titleViews || 'Views'
    }
  }))
  document.querySelector('.sc-loader-flat')?.remove()
  return manageCache(cacheKey, cache, shorts)
}

function generateCarouselSlides(shortsData, container, config) {
  const { maxCount, arrows } = config
  const uniqueId = `carousel-${Date.now()}`
  const slidesHtml = shortsData
    .slice(0, maxCount)
    .map((block, index) => `
      <div class="sc-carousel-slide shorts-carousel" data-index="${index}">
        <div class="sc-carousel-slide-bg relative-shorts shorts-border">
          <a href="${block.settings.url}" target="_blank">
            <div class="sc-carousel-slide-bg-image shorts-carousel-img">
              <img src="${block.settings.image}" alt="${block.settings.title}" style="width: 100%">
            </div>
          </a>
        </div>
        <div class="sc-carousel-slide-content relative-shorts shorts-content-h">
          <div class="sc-carousel-slide-content-wrap">
            <div class="shorts-title">
              <a href="${block.settings.url}" target="_blank">
                ${block.settings.title}
              </a>
            </div>
            <div class="shorts-views">
              ${block.settings.views} ${block.settings.title_views}
            </div>
          </div>
        </div>
      </div>
    `)
    .join('')
  const slideshowElement = document.createElement('x-slideshow')
  slideshowElement.setAttribute('swipeable', 'true')
  slideshowElement.setAttribute('class', 'sc-slideshow slideshow slideshow--multiple-slides content-over-media--lg')
  const carouselElement = document.createElement('slideshow-carousel')
  carouselElement.setAttribute('id', uniqueId)
  carouselElement.setAttribute('class', 'slideshow__carousel')
  carouselElement.setAttribute('selector', 'sc-carousel-slide')
  const slidesWrap = document.createElement('div')
  slidesWrap.setAttribute('class', 'sc-slideshow-wrap sc-carousel-wrap')
  slidesWrap.innerHTML = slidesHtml
  carouselElement.appendChild(slidesWrap)
  slideshowElement.appendChild(carouselElement)
  if (arrows === 'on') {
    const prevButton = document.createElement('button')
    prevButton.setAttribute('is', 'prev-button')
    prevButton.setAttribute('style', 'top: 45%')
    prevButton.setAttribute('aria-controls', uniqueId)
    prevButton.setAttribute('class', 'group sc-carousel-controll-button sc-carousel-controll-button_prev rave')
    prevButton.innerHTML = '<span class="animated-arrow animated-arrow--reverse"></span>'
    const nextButton = document.createElement('button')
    nextButton.setAttribute('is', 'next-button')
    nextButton.setAttribute('style', 'top: 45%')
    nextButton.setAttribute('aria-controls', uniqueId)
    nextButton.setAttribute('class', 'group sc-carousel-controll-button sc-carousel-controll-button_next rave')
    nextButton.innerHTML = '<span class="animated-arrow"></span>'
    slideshowElement.appendChild(prevButton)
    slideshowElement.appendChild(nextButton)
  }
  const carouselContainer = container.querySelector('.sc-blogs_shorts-videos')
  if (!carouselContainer) {
    console.error('Container .sc-blogs_shorts-videos not found')
    return
  }
  carouselContainer.appendChild(slideshowElement)
}

async function initShortsSections() {
  const sections = document.querySelectorAll('.sc-blogs_shorts')
  for (const section of sections) {
    const config = {
      apiKey: section.dataset.apiKey,
      ytUrl: section.dataset.ytUrl,
      maxCount: parseInt(section.dataset.max, 10),
      cache: section.dataset.cache,
      arrows: section.dataset.arrows,
      titleViews: section.dataset.titleViews,
      sort: section.dataset.sort
    }
    try {
      const shortsData = await fetchShortsData(config)
      if (shortsData.length > 0) {
        generateCarouselSlides(shortsData, section, config)
        const slideshow = section.querySelector('.sc-slideshow')
        if (slideshow?.querySelector('.sc-carousel-wrap')) {
          new CarouselShorts(slideshow)
        }
      }
    } catch (e) {
      console.error('Failed to initialize shorts section:', e)
    }
  }
}

initShortsSections()

function _refreshYTShorts() {
  let Store = JSON.parse(localStorage.getItem('ytshorts_keys'))
  for(let key of Store) {
    localStorage.removeItem(key)
  }
  
  localStorage.removeItem('ytshorts_keys')
}